import { cn } from 'Utils/Helpers'
import { getHTMLDataTestID } from 'infra/utils'
import { Label, Typography } from 'procyon-ui'
import React from 'react'

function LabelContent({
  title,
  content,
  showEmptyLabel = false,
  className = '',
  fullWidth = false,
  titleBreakAll = true,
  dataTestId = null,
  'data-testid': dataTestIdAttr = null
}) {
  return (
    <div
      className={cn(
        'flex border-b border-[var(--color-common-border)] py-2 min-h-[58px] items-center',
        className
      )}
    >
      {/* Left column (label/title) */}
      <div
        data-testid={getHTMLDataTestID(
          'lable-title',
          'div',
          dataTestIdAttr?.toLowerCase().replace(/\s+/g, '-')
        )}
        className='w-52 flex-shrink-0 pr-4 flex items-start'
      >
        <Typography
          className={cn('!font-semibold', {
            '!break-all': titleBreakAll
          })}
          variant='h5'
        >
          {title}
        </Typography>
      </div>

      {/* Right column (content/value) */}
      <div
        data-testid={getHTMLDataTestID('label-content', 'div', dataTestIdAttr)}
        className='flex-1 flex items-center'
      >
        {!content && showEmptyLabel && (
          <Label
            text={
              <Typography variant='body-small'>
                <em className='text-[var(--color-font-light)]'>Empty</em>
              </Typography>
            }
            variant='gray'
          />
        )}

        {typeof content === 'string' ? (
          <Typography
            data-testid={getHTMLDataTestID('label-content', 'div', dataTestIdAttr)}
            className='!break-all'
            variant='body-regular'
          >
            {content}
          </Typography>
        ) : (
          <div
            data-testid={getHTMLDataTestID('label-content', 'div', dataTestIdAttr)}
            className={cn('w-auto text-[var(--color-common-font-light)]', { '!w-full': fullWidth })}
          >
            {content}
          </div>
        )}
      </div>
    </div>
  )
}

export { LabelContent }
